import { useState, type ReactNode } from 'react';
import { Link } from 'react-router-dom';

import { MIN_USER_AGE } from '@/config/legal';

import { hasAcceptedTerms, writeTermsAcceptance } from './acceptance-store';

/**
 * Экран «Перед началом»: до принятия документов и подтверждения возраста
 * приложение не показывается и не обращается к серверу (профиль и стартовые
 * кредиты заводятся только ниже по дереву). Автоматического согласия нет —
 * нужна явная отметка. Документы открываются отсюда же.
 */
export function TermsGate({ children }: { children: ReactNode }) {
  const [accepted, setAccepted] = useState(hasAcceptedTerms);
  const [checked, setChecked] = useState(false);

  if (accepted) {
    return <>{children}</>;
  }

  function confirm() {
    writeTermsAcceptance();
    setAccepted(true);
  }

  return (
    <main className="mx-auto flex min-h-dvh max-w-2xl flex-col justify-center gap-6 px-6 py-10">
      <div>
        <h1 className="font-display text-h1 text-text">Перед началом</h1>
        <p className="mt-2 text-text-2">
          Сервис предназначен для пользователей от {MIN_USER_AGE} лет. Чтобы продолжить,
          познакомьтесь с документами и подтвердите согласие.
        </p>
      </div>

      <ul className="flex flex-col gap-2 text-sm">
        <li>
          <Link to="/terms" className="text-accent hover:underline">
            Условия использования
          </Link>
        </li>
        <li>
          <Link to="/privacy" className="text-accent hover:underline">
            Политика обработки персональных данных
          </Link>
        </li>
      </ul>

      <label className="flex items-start gap-3 text-sm text-text">
        <input
          type="checkbox"
          checked={checked}
          onChange={(event) => setChecked(event.target.checked)}
          className="mt-1 h-5 w-5 shrink-0"
        />
        <span>
          Мне есть {MIN_USER_AGE} лет. Я прочитал(а) Условия использования и Политику обработки
          персональных данных и принимаю их.
        </span>
      </label>

      <button
        type="button"
        onClick={confirm}
        disabled={!checked}
        className="btn btn-primary px-4 py-3"
      >
        Продолжить
      </button>
    </main>
  );
}
